"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentPanelImpactDataFieldApi = contentPanelImpactDataFieldApi;
exports.contentPanelTypeListApi = contentPanelTypeListApi;
exports.interactionCreateApi = interactionCreateApi;
exports.interactionDeleteBulkApi = interactionDeleteBulkApi;
exports.interactionDownloadResponseApi = interactionDownloadResponseApi;
exports.interactionDownloadResponseCpApi = interactionDownloadResponseCpApi;
exports.interactionFetchApi = interactionFetchApi;
exports.interactionFetchListApi = interactionFetchListApi;
exports.interactionFinalSaveApi = interactionFinalSaveApi;
exports.interactionFinalUpdateApi = interactionFinalUpdateApi;
exports.interactionHardDeleteApi = interactionHardDeleteApi;
exports.interactionIPFolderAddApi = interactionIPFolderAddApi;
exports.interactionIPFolderDeleteApi = interactionIPFolderDeleteApi;
exports.interactionIPFolderDeleteBulkApi = interactionIPFolderDeleteBulkApi;
exports.interactionIPFolderDeleteSoftApi = interactionIPFolderDeleteSoftApi;
exports.interactionIPFolderDeleteSoftBulkApi = interactionIPFolderDeleteSoftBulkApi;
exports.interactionIPFolderFetchApi = interactionIPFolderFetchApi;
exports.interactionIPFolderUpdateApi = interactionIPFolderUpdateApi;
exports.interactionResponseListApi = interactionResponseListApi;
exports.interactionResponseSubmitApi = interactionResponseSubmitApi;
exports.interactionRestoreApi = interactionRestoreApi;
exports.interactionRestoreBulkApi = interactionRestoreBulkApi;
exports.interactionRestoreBulkFolderApi = interactionRestoreBulkFolderApi;
exports.interactionRestoreFolderApi = interactionRestoreFolderApi;
exports.interactionSoftDeleteApi = interactionSoftDeleteApi;
exports.interactionSoftDeleteBulkApi = interactionSoftDeleteBulkApi;
exports.interactionSoftDeleteListApi = interactionSoftDeleteListApi;
exports.interactionSoftDeleteListFolderApi = interactionSoftDeleteListFolderApi;
exports.interactionSubFolderListApi = interactionSubFolderListApi;
exports.interactionUpdateApi = interactionUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * type list
 * @param payload
 * @returns api response
 * @description this function used to get the type list.
 */
function contentPanelTypeListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.typeList), params);
}
/**
 * impact data field
 * @param payload
 * @returns api response
 * @description this function used to get impact data field.
 */
function contentPanelImpactDataFieldApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.impactDataField), params);
}

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
function interactionCreateApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.create), payload);
}

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 */
function interactionUpdateApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.update), payload);
}

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
function interactionFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.fetch), params);
}

/**
 * Fetch List
 * @param payload
 * @returns api response
 * @description this function used to Fetch List.
 */
function interactionFetchListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.fetchList), params);
}

/**
 * Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete.
 */
function interactionSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.softDelete), params);
}

/**
 * Hard Delete
 * @param payload
 * @returns api response
 * @description this function used to Hard Delete.
 */
function interactionHardDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.hardDelete), params);
}

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
function interactionRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.restore), params);
}

/**
 * Soft Delete List
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete List.
 */
function interactionSoftDeleteListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.softDeleteList), params);
}

/**
 * Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete Bulk.
 */
function interactionSoftDeleteBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.softDeleteBulk), params);
}

/**
 * Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Delete Bulk.
 */
function interactionDeleteBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.deleteBulk), params);
}

/**
 * Restore Bulk
 * @param payload
 * @returns api response
 * @description this function used to Restore Bulk.
 */
function interactionRestoreBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.restoreBulk), params);
}

/**
 * Final Save
 * @param payload
 * @returns api response
 * @description this function used to Final save.
 */
function interactionFinalSaveApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.finalSave), params);
}

/**
 * Final Update
 * @param payload
 * @returns api response
 * @description this function used to Final update.
 */
function interactionFinalUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.finalUpdate), params);
}

/**
 * Sub Folder List
 * @param payload
 * @returns api response
 * @description this function used to Sub Folder List.
 */
function interactionSubFolderListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.subFolderList), params);
}

/**
 * Download Response
 * @param payload
 * @returns api response
 * @description this function used to dwonload data.
 */
function interactionDownloadResponseApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ExportService.interaction.downloadResponse), params);
}

/**
 * Download Response CP
 * @param payload
 * @returns api response
 * @description this function used to download response cp.
 */
function interactionDownloadResponseCpApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.downloadResponseCp), params);
}

/**
 * IP Folder Fetch
 * @param payload
 * @returns api response
 * @description this function used to IP Folder Fetch.
 */
function interactionIPFolderFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.ipFolderFetch), params);
}

/**
 * IP Folder Add
 * @param payload
 * @returns api response
 * @description this function used to IP Folder Add.
 */
function interactionIPFolderAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.ipFolderAdd), params);
}

/**
 * IP Folder Update
 * @param payload
 * @returns api response
 * @description this function used to IP Folder Update.
 */
function interactionIPFolderUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.ipFolderUpdate), params);
}

/**
 * IP Folder Delete
 * @param payload
 * @returns api response
 * @description this function used to IP Folder Delete.
 */
function interactionIPFolderDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.ipFolderDelete), params);
}

/**
 * Response List
 * @param payload
 * @returns api response
 * @description this function used to Response List.
 */
function interactionResponseListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.responseList), params);
}

/**
 * Response Submit
 * @param payload
 * @returns api response
 * @description this function used to Response Submit.
 */
function interactionResponseSubmitApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.responseSubmit), params);
}

/**
 * IP Folder Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to IP Folder Delete Bulk.
 */
function interactionIPFolderDeleteBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.ipFolderDeleteBulk), params);
}

/**
 * IP Folder Delete Soft
 * @param payload
 * @returns api response
 * @description this function used to IP Folder Delete Soft.
 */
function interactionIPFolderDeleteSoftApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.ipFolderDeleteSoft), params);
}

/**
 * IP Folder Delete Soft Bulk
 * @param payload
 * @returns api response
 * @description this function used to IP Folder Delete Soft Bulk.
 */
function interactionIPFolderDeleteSoftBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.ipFolderDeleteSoftBulk), params);
}

/**
 * Soft Delete List Folder
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete List Folder.
 */
function interactionSoftDeleteListFolderApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.softDeleteListFolder), params);
}

/**
 * Restore Folder
 * @param payload
 * @returns api response
 * @description this function used to Restore Folder.
 */
function interactionRestoreFolderApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.restoreFolder), params);
}

/**
 * Restore Bulk Folder
 * @param payload
 * @returns api response
 * @description this function used to Restore Bulk Folder.
 */
function interactionRestoreBulkFolderApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.interaction.restoreBulkFolder), params);
}